import React from "react";
import {Col} from "react-bootstrap";

type Sizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Props = {
  children: React.ReactNode;

  id?: string;
  className?: string;

  small?: Sizes;
  medium?: Sizes;
  large?: Sizes;
  extraLarge?: Sizes;
};

const Column = (props: Props) => {
  return (
    <Col xl={props.extraLarge} lg={props.large} md={props.medium} sm={props.small} id={props.id} className={props.className}>
      {props.children}
    </Col>
  );
};

export default Column;
